import styled from "styled-components";
import { getFontSize } from "utils/text-styles";

export const Button = styled.button`
  background-color: ${(props) => props.theme.theme.BUTTON.BACKGROUND.PRIMARY};
  color: ${(props) => props.theme.theme.BUTTON.TEXT.PRIMARY} !important;
  border: 1px solid ${(props) => props.theme.theme.DIVIDER_COLOR} !important;
  cursor: pointer;
  height: 50px;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${(props) => getFontSize(props.theme.fontSize, "text")} !important;
  line-height: 1;

  &:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background-color: ${(props) =>
      props.theme.theme.BUTTON.BACKGROUND.PRIMARY} !important;
  }

  &:active {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background-color: ${(props) =>
      props.theme.theme.BUTTON.BACKGROUND.PRIMARY} !important;
  }

  &:focus {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background-color: ${(props) =>
      props.theme.theme.BUTTON.BACKGROUND.PRIMARY} !important;
  }

  &:disabled {
    background-color: ${(props) => props.theme.theme.BUTTON.BACKGROUND.LIGHT};
    color: ${(props) => props.theme.theme.BUTTON.TEXT.LIGHT} !important;
    cursor: not-allowed;
  }

  &.secondary {
    background-color: ${(props) =>
      props.theme.theme.BUTTON.BACKGROUND.SECONDARY};
    color: ${(props) => props.theme.theme.BUTTON.TEXT.SECONDARY} !important;

    &:hover {
      background-color: ${(props) =>
        props.theme.theme.BUTTON.BACKGROUND.SECONDARY} !important;
    }
  }

  &.success {
    background-color: ${(props) => props.theme.theme.BUTTON.BACKGROUND.SUCCESS};
    color: ${(props) => props.theme.theme.BUTTON.TEXT.LIGHT} !important;
  }

  &.warning {
    background-color: ${(props) => props.theme.theme.BUTTON.BACKGROUND.WARNING};
    color: ${(props) => props.theme.theme.BUTTON.TEXT.WARNING} !important;
  }

  &.danger {
    background-color: ${(props) => props.theme.theme.BUTTON.BACKGROUND.DANGER};
    color: ${(props) => props.theme.theme.BUTTON.TEXT.DANGER} !important;
  }

  &.info {
    background-color: ${(props) => props.theme.theme.BUTTON.BACKGROUND.INFO};
    color: ${(props) => props.theme.theme.BUTTON.TEXT.INFO} !important;
  }

  &.light {
    background-color: ${(props) => props.theme.theme.BUTTON.BACKGROUND.LIGHT};
    color: ${(props) => props.theme.theme.BUTTON.TEXT.LIGHT} !important;
  }

  &.dark {
    background-color: ${(props) => props.theme.theme.BUTTON.BACKGROUND.DARK};
    color: ${(props) => props.theme.theme.BUTTON.TEXT.DARK} !important;
  }

  &.btn-cu {
    display: flex;
    height: 67px;
    width: 280px;
    justify-content: center;
    padding: 8px 18px 8px 15px !important;
    font-family: Roboto, sans-serif;
    font-size: ${(props) =>
      getFontSize(props.theme.fontSize, "text")} !important;
    font-weight: 400;
    line-height: 1.6em;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border-radius: 0;

    &:focus {
      background-color: #0c549c;
      outline: 1px dashed #000;
    }
  }

  &.btn-ct {
    display: flex;
    height: 67px;
    width: 280px;
    justify-content: center;
    padding: 8px 18px 8px 15px !important;
    font-family: Roboto, sans-serif;
    font-size: ${(props) =>
      getFontSize(props.theme.fontSize, "text")} !important;
    font-weight: 400;
    line-height: 1.6em;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border-radius: 0;
    background-color: #08324e;

    &:focus {
      background-color: #08324e;
      outline: 1px dashed #000;
    }
  }

  &.btn-s {
    height: 36px;
    padding: 8px 10px !important;
    font-size: ${(props) =>
      getFontSize(props.theme.fontSize, "link")} !important;
  }

  &.btn-m {
    height: 42px;
    padding: 8px 18px 8px 15px !important;
    font-size: ${(props) =>
      getFontSize(props.theme.fontSize, "text")} !important;
    line-height: 1.6em;
  }

  &.btn-l {
    height: 48px;
    padding: 11px 12px !important;
    font-size: ${(props) =>
      getFontSize(props.theme.fontSize, "subtitle")} !important;
  }

  &.btn-fw {
    display: flex;
    justify-content: center;
  }

  .cl-claveunica {
    color: ${(props) => props.theme.theme.BUTTON.TEXT.PRIMARY};
    font-size: ${(props) =>
      getFontSize(props.theme.fontSize, "link")} !important;
    font-weight: 500;
    margin-right: 10px;
    float: left;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .texto {
    padding-left: 3px !important;
    text-decoration: underline !important;
    color: ${(props) => props.theme.theme.BUTTON.TEXT.PRIMARY} !important;
    margin: 0;
  }
`;
